import { isEmpty, trim } from 'lodash';
import { DateTime } from 'luxon';

/**
 * Checks if a string is empty, contains only whitespace, tabs, or other empty characters
 * @param value - The string to check
 * @returns true if the string is empty or contains only whitespace characters
 */
export const isEmptyOrWhitespace = (
  value: string | number | Date | DateTime | null | undefined
): boolean => {
  if (value === null || value === undefined) {
    return true;
  }

  const stringValue = String(value);
  const trimmedValue = trim(stringValue);

  return isEmpty(trimmedValue);
};
